// extracted by mini-css-extract-plugin
export var avatarContainer = "_18-0";
export var avatarTypingWave = "_18-i";
export var gray = "_18-f";
export var green = "_18-c";
export var icon = "_18-9";
export var image = "_18-1";
export var lg = "_18-6";
export var md = "_18-5";
export var presenceDot = "_18-b";
export var red = "_18-d";
export var sm = "_18-4";
export var status = "_18-a";
export var typingDot = "_18-h";
export var typingPill = "_18-g";
export var xl = "_18-7";
export var xs = "_18-3";
export var xxl = "_18-8";
export var xxs = "_18-2";
export var yellow = "_18-e";